import React from 'react'

import { ReactComponent as LoadingIcon } from 'assets/svg/loading.svg'
import './style.scss'

export function Loading({ isLoaderInSelect = false }) {
    return (
        <div className={`loading ${isLoaderInSelect && 'select-loader'}`}>
            <LoadingIcon />
        </div>
    )
}
